export const phoneMask = (rawValue: string) => {
  const digits = rawValue.replace(/\D/g, '');

  if (digits.length > 10) {
    // celular com 9 dígitos
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  } else {
    // telefone fixo com 8 dígitos
    return [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ];
  }
};

export const cepMaskforText = '00000-000';
export const phoneMaskForText = '(99)99999-9999';

export const maskCpfCnpj = (rawValue: string): (string | RegExp)[] => {
  return rawValue.replace(/[^\w\s]/gi, '').length <= 11 // replace remove caracteres especiais
    ? [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    : [
        /[0-9]/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '/',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ];
};
